export default class PublishButtons {
  constructor() {
    this.$pageElement = $('#admin-page-publish-check-box');
    this.$groupElement = $('#admin-group-publish-check-box');
    this.$guideRadioElement = $('#admin-guide-status-radios');
    this.$guideCheckboxElement = $('#admin-guide-publish-check-box');

    this.initSwitches();
  }

  initSwitches() {
    this.$pageElement.on('change', this.toggleChange.bind(this));
    this.$groupElement.on('change', this.toggleChange.bind(this));
    this.$guideCheckboxElement.on('change', this.toggleGuideChange.bind(this));
    this.$guideRadioElement.on('change', this.onGuideChange.bind(this));
  }

  toggleChange(event) {
   var $checkBox = $(event.currentTarget);
   this.toggleStatus($checkBox, $checkBox.prop('checked'));
  }

  toggleGuideChange(event) {
    var $element = $(event.currentTarget);
    this.setStatusDetails($element, {status: "Processing"});

    $.ajax({
      url: $element.data('url'),
      type: 'put'
    })
      .done(this.setStatusDetails.bind(this, $element))
      .fail(this.handleGuidePublishError.bind(this, $element));
  }

  onGuideChange(event) {
    var $element = $(event.target)
    this.setStatusDetails($element, { status: "Processing" });
    $.ajax({
      url: this.$guideRadioElement[0].action,
      type: 'put',
      data: { guide_status: $element.val() }
    }).done(this.handleGuideStatusChange.bind(this, $element))
    .fail(this.handleGuidePublishError.bind(this, $element));
  }

  handleGuideStatusChange($element, data, xhrStatus) {
    $('#publish-guide').html(data.content);
    this.$guideRadioElement.on('change', this.onGuideChange.bind(this));
  }

  handleGuidePublishError($element, data, xhrStatus) {
    $('#publish-guide').html(data.responseJSON.content);
    this.$guideRadioElement.on('change', this.onGuideChange.bind(this));

    if (data.status === 422) {
      alert("Please complete the following prior to publishing: \n" + data.responseJSON.errors);
      $element.prop("checked", !$element.prop("checked"));
    }
  }

  handlePagePublishError($element, data, xhrStatus) {
    var status = "error";

    if (data.status === 500) {
      status = "Server error";
    }

    this.setStatusDetails($element, {status: status});
  }

  toggleStatus($element, state) {
    this.setStatusDetails($element, {status: "Processing"});

    $.ajax({
      url: $element.data('url'),
      type: 'put'
    })
      .done(this.setStatusDetails.bind(this, $element))
      .fail(this.handlePagePublishError.bind(this, $element));
  }

  setStatusDetails($element, data) {
    let status = data.status;
    if (data.status === "moderation") {
      status = "pending review";
    }

    $element.closest('li').find('.status-details').text(status.charAt(0).toUpperCase() + status.slice(1));
  }
}
